import { RootState } from 'store/rootSlices';

export const getAppSlice = (state: RootState) => state.App;
export const getGradesGuideSlice = (state: RootState) => state.GradesGuide;
